import { Injectable } from '@angular/core';
import { CaiApi } from '../../utils/cai-api';
import { API_CORE } from '../../constant/api-core.const';
import { QuoteRequestStatusEnum, QuoteStatusEnum } from '../../enum';

@Injectable({
  providedIn: 'root',
})
export class AllotmentService {
  async getAllotments(
    page: number,
    size: number,
    sort: string,
    officeId: number,
    search?: string,
    filenames?: string[],
    inStatus?: QuoteRequestStatusEnum[],
    inQuoteStatus?: QuoteStatusEnum[],
  ): Promise<any> {
    const extraOptions = {
      queryParams: {
        page,
        size,
        officeId,
      } as any,
    };
    if (sort) {
      extraOptions.queryParams.sort = sort;
    }
    if (search) {
      extraOptions.queryParams.search = search;
    }
    if (filenames?.length) {
      extraOptions.queryParams.filenames = filenames.join(',');
    }
    if (inStatus?.length) {
      extraOptions.queryParams.inStatus = inStatus.join(',');
    }
    if (inQuoteStatus?.length) {
      extraOptions.queryParams.inQuoteStatus = inQuoteStatus.join(',');
    }
    return CaiApi.get(
      API_CORE.name,
      API_CORE.URLs.Allotment.Allotments,
      extraOptions,
    );
  }

  async getFilenames(officeId: number): Promise<string[]> {
    const extraOptions = {
      queryParams: {
        officeId,
      },
    };
    return CaiApi.get(
      API_CORE.name,
      API_CORE.URLs.Allotment.Filenames,
      extraOptions,
    );
  }

  async postAllotmentSummaryEmail(filename: string): Promise<void> {
    const extraOptions = {
      queryParams: {
        filename,
      },
    };
    return CaiApi.put(
      API_CORE.name,
      API_CORE.URLs.Allotment.Summary,
      extraOptions,
    );
  }
}
